import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadband',
  templateUrl: './broadband.component.html',
  styleUrls: ['./broadband.component.css']
})
export class BroadbandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
